<template>
  <SmartFeed
    :source="useDigitalProductStoreFeedStore"
    :default-feed-layout="getOptionValue(SmartFeedLayout)"
    :default-entity-size="getOptionValue(SmartFeedCardLayout)"
    :edit-mode="editMode"
  >
    <template #empty-state>
      <iSpace :height="10" />
      <iColumn gap="large" align="center">
        <iColumn gap="standard" align="center">
          <iSubHeading variant="subtle" font-size="large">
            No Digital Products Available
          </iSubHeading>
          <iParagraph
            variant="subtle"
            text-align="center"
            :max-width="400"
          >
            There are currently no digital items in this store's collection.
            We recommend checking back later as new products are added regularly.
          </iParagraph>
        </iColumn>
      </iColumn>
    </template>
  </SmartFeed>
</template>

<script>
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import { SmartFeedElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-element-mixin";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import { useDigitalProductStoreFeedStore } from "SmartFeed/stores/feed/digital-product-store-feed-store";
import EmptyStateText from "%/dynamic-component-editor/options/empty-state-text";

export default {
  name: "DigitalProductStore",
  components: {
    SmartFeed,
  },
  mixins: [
    DynamicElementMixin,
    SmartFeedElementMixin,
  ],
  elementPanelSettings: {
    displayName: "Store Digital Products",
    displayIcon: "feed",
    elementGroup: "digitalProductStoreElements",
    elementType: "element",
  },
  options: [
    new LayoutWidth({
      "default": "fill",
      "hover": "fill",
    }, true),
    new EmptyStateText({ "default": "No digital products have been published yet." }),
  ],
  methods: {
    useDigitalProductStoreFeedStore,
  },
};
</script>

<style scoped lang="scss">
</style>

